import PropTypes from 'prop-types'

import { Modal } from '@/components/Modal'
import CourseComplete from '@/pages/Students/Course/CourseComplete'

import StudentCourseProgress from './StudentCourseProgress'

function StudentCourseModal({ courseRecord, onClose, entityId, name }) {
  const isCompleted = courseRecord.status === 'Completed'

  return (
    <Modal
      title={courseRecord.course.name}
      description={isCompleted ? `Results for ${name}` : `Progress for ${name}`}
      size="xl"
      actions={[]}
      contentClasses="max-h-[90vh] overflow-y-auto"
      content={
        <div>
          {isCompleted ? (
            <CourseComplete
              courseRecord={courseRecord}
              openToContent={() => {}}
              entityId={entityId}
              includeReviewLink={false}
              isInstructorView
            />
          ) : (
            <StudentCourseProgress courseRecord={courseRecord} entityId={entityId} />
          )}
        </div>
      }
      setOpen={onClose}
    />
  )
}

export default StudentCourseModal

StudentCourseModal.propTypes = {
  courseRecord: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  entityId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}
